import { BorderGridContainer, GridBox } from '@ahmdigital/ui';
import { isEmpty } from 'lodash/fp';
import { useSelector } from 'react-redux';

import { VARIANT } from '../../../../components/offers/tile/constants';
import filterOffersByProductType from '../../../../utils/filter-offers-by-product-type';
import OfferTile from '../../../../components/offers/tile';
import selectCustomer from '../../../../selectors/select-customer';
import type { Offer, Placeholder } from '../../../../components/offers/types';

type OfferSectionProps = {
  offers: Offer[];
  placeholders: Placeholder[];
};

const OfferSection = ({ offers, placeholders }: OfferSectionProps) => {
  const customer = useSelector(selectCustomer);

  const hasActiveOffers = !isEmpty(offers);
  if (!hasActiveOffers) {
    return null;
  }

  const productType = customer?.productType;
  const filteredOffer = filterOffersByProductType(productType, offers) as Offer;

  return (
    <BorderGridContainer hideBorderTop>
      <GridBox padding="1rem">
        <OfferTile
          isBoxed={false}
          overrideOffers={[filteredOffer]}
          placeholders={placeholders}
          variant={VARIANT.STRIP}
        />
      </GridBox>
    </BorderGridContainer>
  );
};

export default OfferSection;
